import { asc, eq } from "drizzle-orm";
import { attachment, type PowerSyncDrizzleDB } from "@apunte-digital/powersync";

export function getAttachmentsByPageQuery(db: PowerSyncDrizzleDB, pageId: string) {
  return db
    .select()
    .from(attachment)
    .where(eq(attachment.page_id, pageId))
    .orderBy(asc(attachment.created_at));
}
